<template>
  <Select v-model="model" :clearable="!disabled" filterable :disabled="disabled" @on-change="onChange" @on-clear="onClear" :placeholder="placeholder">
    <Option v-for="item in adminUserList" :value="item.id" :key="item.id">{{ item.nickname + ' - ' + item.phone }}</Option>
  </Select>
</template>
<script>
  export default {
    name: 'AdminUserSelect',
    props: {
      value: {
        type: [Number, String],
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      status: {
        type: [Number, String],
        default: 1
      },
      adminGroupCode: {
        type: String,
        default: ''
      },
      needDefaultStudyAdviser: {
        type: Number,
        default: 1
      },
      notInId: {
        type: Array,
        default: () => []
      },
      // 是否限制非部门负责人只能看到自己：true=限制（默认）, false=显示所有人
      restrictToSelf: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        adminGroupList: [{id: 4, code: 'userStudyAdviser'}, {id: 7, code: 'tchStudyAdviser'}, {id: 10, code: 'adviser'}, {id: 6, code: 'market'}],
        adminUserList: [],
        model: ''
      }
    },
    methods: {
      getAdminGroupId () {
        let adminGroupId = ''
        if (this.adminGroupCode === '') {
          return adminGroupId
        }
        let code = this.adminGroupCode
        this.adminGroupList.forEach(element => {
          if (element.code === code) {
            adminGroupId = element.id
          }
        })
        return adminGroupId
      },
      onChange (value) {
        this.$emit('input', value)
        this.$emit('on-change', value)
      },
      onClear () {
        this.$emit('input', null)
        this.$emit('on-clear')
      },
    },
    created: function () {
      if (this.value) {
        this.model = parseInt(this.value)
      }
    },
    mounted: function () {
      let self = this
      let params = { status: self.status, adminGroupId: self.getAdminGroupId(), needDefaultStudyAdviser: self.needDefaultStudyAdviser }
      self.$http.get('/adminUser/listByCondition', { params: params }).then(function (res) {
        if (res && res.data) {
          // 去重：确保每个 id 只保留一条数据
          const uniqueData = []
          const idSet = new Set()
          res.data.forEach(item => {
            if (!idSet.has(item.id)) {
              idSet.add(item.id)
              uniqueData.push(item)
            }
          })

          // 过滤掉 notInId 数组中的用户
          if (self.notInId && self.notInId.length > 0) {
            self.adminUserList = uniqueData.filter(item => !self.notInId.includes(item.id))
          } else {
            self.adminUserList = uniqueData
          }

          // 若当前用户不是部门负责人，则只显示其自身
          if (self.restrictToSelf && self.$store.get('depLeader') !== true) {
            const currentUserId = self.$store.get('id')
            self.adminUserList = self.adminUserList.filter(item => item.id === currentUserId)
          }
          if (self.disabled) {
            const currentUserId = parseInt(self.$store.get('id'))
            self.adminUserList = self.adminUserList.filter(item => item.id === currentUserId)
            if (self.adminUserList.length === 0 && currentUserId) {
              self.adminUserList = [{id: currentUserId, nickname: '本人', phone: ''}]
            }
            self.model = currentUserId
            self.$emit('input', currentUserId)
          }
        } else {
          self.adminUserList = []
        }
      })
    },
    watch: {
      value (val) {
        if (val) {
          let idNumber = parseInt(val)
          this.model = idNumber
        } else {
          this.model = null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AdminUserSelect.vue?19f79a09